import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pathManager } from 'routes';

import { Box, Chip, Tooltip } from '@mui/material';

import { Talent } from '@libs/graphql-types';
import { stopEvent } from '@libs/helpers/common';

interface JobApplicationChipProps {
  talent: Talent;
}

export const JobApplicationChip = ({ talent }: JobApplicationChipProps) => {
  const { t } = useTranslation('workforce');
  const appliedJob = talent?.job_applications?.[0]?.job;
  const appliedJobId = appliedJob?.id;

  if (!appliedJobId) {
    return <></>;
  }

  const jobName = appliedJob?.name;

  const jobLink = pathManager.company.job.generatePath({ id: appliedJobId });

  return (
    <Box onClick={stopEvent}>
      <Link to={jobLink} style={{ display: 'flex' }}>
        <Tooltip title={`Applied for "${jobName}"`}>
          <Chip
            style={{ color: 'white', cursor: 'pointer' }}
            size="small"
            label={t('talentCard.appliedForJob')}
            color="success"
          />
        </Tooltip>
      </Link>
    </Box>
  );
};
